const updateCartReducer = (state = [] ,action) => {
    switch (action.type){
        case "UPDATE_CART_LIST":
            return action.payload;
        default :
            return state;
    }
}

export default updateCartReducer;